/** Restores Inventory sub-screens after leaving hidden drawer routes (no URL params). */
let pendingSelectedItem: string | null = null;
let pendingData: unknown = null;

/** Where Quick Scan should return: null = Inventory hub, string = sub-screen title. */
let quickScanReturnSubItem: string | null | undefined = undefined;

export const setPendingInventoryScreen = (item: string, data?: unknown) => {
  pendingSelectedItem = item;
  pendingData = data ?? null;
};

export const consumePendingInventoryScreen = (): { item: string | null; data: unknown } => {
  const item = pendingSelectedItem;
  const data = pendingData;
  pendingSelectedItem = null;
  pendingData = null;
  return { item, data };
};

export const setQuickScanReturnSubItem = (item: string | null) => {
  quickScanReturnSubItem = item;
};

export const consumeQuickScanReturnSubItem = (): string | null | undefined => {
  const value = quickScanReturnSubItem;
  quickScanReturnSubItem = undefined;
  return value;
};

export const navigateBackToInventory = (
  navigation: { navigate: (name: string) => void },
  subItem: string | null | undefined,
) => {
  if (subItem) {
    setPendingInventoryScreen(subItem);
  }
  navigation.navigate('Inventory');
};
